import { Skeleton } from "@mui/material";
import { useTranslation } from "react-i18next";

import styles from "./ReportReader.module.css";

const PLACEHOLDER_FIELDS = 8;

export default function ReportLoadingSkeleton(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      className={styles.reader}
      role="status"
      aria-busy="true"
      aria-label={t("Loading")}
      data-testid="report-loading-skeleton"
    >
      <div aria-hidden="true">
        <div className={styles.header}>
          <div className={styles.loadingTitle}>
            <Skeleton variant="text" width="70%" height={36} />
            <Skeleton variant="text" width="50%" height={22} />
          </div>
          <Skeleton variant="rounded" width={108} height={36} />
        </div>
        <div className={styles.tools}>
          <Skeleton variant="rounded" height={40} />
          <div className={styles.summary}>
            <Skeleton variant="rounded" height={40} />
            <Skeleton variant="rounded" height={40} sx={{ mt: 1 }} />
          </div>
          <Skeleton variant="text" width="60%" height={32} />
        </div>
        <div className={styles.loadingContent}>
          <Skeleton variant="text" width="35%" height={28} />
          <div className={styles.answerGrid}>
            {Array.from({ length: PLACEHOLDER_FIELDS }, (_, index) => (
              <div key={index}>
                <Skeleton variant="text" width="65%" height={22} />
                <Skeleton variant="text" width="85%" height={28} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
